var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as _ from "lodash";
// React
import React from "react";
import { connect } from "react-redux";
import * as userDomain from "user/user/User";
const mapStateToProps = (state, props) => ({
    user: state.user
});
const mapDispatchToProps = (dispatch) => ({});
//-- Component -------------------------------------------------------------------------------------------------------------------------------
let ShowByLoginType = class ShowByLoginType extends React.Component {
    render() {
        let { user, showOnLoginTypes } = this.props;
        if (_.includes(showOnLoginTypes, user.loginUserType)) {
            return React.createElement("div", null, this.props.children);
        }
        else {
            return React.createElement("div", null);
        }
    }
};
ShowByLoginType = __decorate([
    connect(mapStateToProps, mapDispatchToProps)
], ShowByLoginType);
export default ShowByLoginType;
export const superUsers = [userDomain.LoginUserType.SalesFull, userDomain.LoginUserType.SupportFull];
export const nonSuperUsers = [userDomain.LoginUserType.SalesOffices, userDomain.LoginUserType.SupportOffices,
    userDomain.LoginUserType.Client, userDomain.LoginUserType.FeedProvider];
//export const nonSuperUsers = [userDomain.LoginUserType.SalesFull, userDomain.LoginUserType.SupportFull];
//export const superUsers = [userDomain.LoginUserType.SalesOffices, userDomain.LoginUserType.SupportOffices,
//                              userDomain.LoginUserType.Client, userDomain.LoginUserType.FeedProvider];
export const internalUsers = [userDomain.LoginUserType.SalesFull, userDomain.LoginUserType.SupportFull,
    userDomain.LoginUserType.SalesOffices, userDomain.LoginUserType.SupportOffices];
export const externalUsers = [userDomain.LoginUserType.Client, userDomain.LoginUserType.FeedProvider];
